import * as React from "react";
import classnames from "classnames";

export type HeaderElementProps = React.HTMLProps<HTMLDivElement>;

export default React.forwardRef<HTMLDivElement>(
  ({ className, children, ...props }: HeaderElementProps, ref: React.RefObject<HTMLDivElement>) => (
    <div ref={ref} className={classnames("header-element", className)} {...props}>
      {children}
    </div>
  )
);
